"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectDictationInterims = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _useDictateInterims3 = _interopRequireDefault(require("../hooks/useDictateInterims"));

var _useDictateState3 = _interopRequireDefault(require("../hooks/useDictateState"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _Constants$DictateSta = _botframeworkWebchatCore.Constants.DictateState,
    DICTATING = _Constants$DictateSta.DICTATING,
    STARTING = _Constants$DictateSta.STARTING,
    STOPPING = _Constants$DictateSta.STOPPING;
var ROOT_CSS = (0, _glamor.css)({
  alignItems: 'center',
  display: 'flex'
});

var connectDictationInterims = function connectDictationInterims() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var dictateInterims = _ref.dictateInterims,
        dictateState = _ref.dictateState,
        language = _ref.language;
    return {
      dictateInterims: dictateInterims,
      dictateState: dictateState,
      language: language
    };
  }].concat(selectors));
};

exports.connectDictationInterims = connectDictationInterims;

var DictationInterims = function DictationInterims(_ref2) {
  var className = _ref2.className;

  var _useDictateInterims = (0, _useDictateInterims3.default)(),
      _useDictateInterims2 = _slicedToArray(_useDictateInterims, 1),
      dictateInterims = _useDictateInterims2[0];

  var _useDictateState = (0, _useDictateState3.default)(),
      _useDictateState2 = _slicedToArray(_useDictateState, 1),
      dictateState = _useDictateState2[0];

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      dictationInterimsStyleSet = _useStyleSet2[0].dictationInterims;

  var localize = (0, _useLocalizer.default)();
  return dictateState === STARTING || dictateState === STOPPING ? _react.default.createElement("p", {
    className: (0, _classnames.default)(dictationInterimsStyleSet + '', ROOT_CSS + '', className + '', 'status')
  }, dictateState === STARTING && localize('SPEECH_INPUT_STARTING')) : dictateState === DICTATING && (dictateInterims.length ? _react.default.createElement("p", {
    className: (0, _classnames.default)(dictationInterimsStyleSet + '', ROOT_CSS + '', className + '', 'dictating')
  }, dictateInterims.map(function (interim, index) {
    return _react.default.createElement("span", {
      key: index
    }, interim, "\xA0");
  })) : _react.default.createElement("p", {
    className: (0, _classnames.default)(dictationInterimsStyleSet + '', ROOT_CSS + '', className + '', 'status')
  }, localize('SPEECH_INPUT_LISTENING')));
};

DictationInterims.defaultProps = {
  className: ''
};
DictationInterims.propTypes = {
  className: _propTypes.default.string
}; // TODO: [P3] After speech started, when clicking on the transcript, it should
//       stop the dictation and allow the user to type-correct the transcript

var _default = DictationInterims;
exports.default = _default;